import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useStore } from '@/context/StoreContext';
import { SignUpForm } from '@/components/auth/AuthForms';
import { Seo } from '@/components/Seo';

export default function SignUp() {
  const { t, customer, customerLoading } = useStore();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get('next') || '/account';

  useEffect(() => { if (!customerLoading && customer) navigate(next, { replace: true }); }, [customer, customerLoading]); // eslint-disable-line

  return (
    <div className="bg-nw-black">
      <Seo title={t.account.createTitle} description={t.account.createSub} path="/account/register" noindex />
      <div className="nw-container py-16 lg:py-24 flex justify-center">
        <div data-testid="signup-page" className="w-full max-w-md bg-nw-espresso border border-nw-gold/20 p-8 sm:p-12">
          <SignUpForm onSuccess={() => navigate(next, { replace: true })} onSwitch={() => navigate(`/account/login${next !== '/account' ? `?next=${encodeURIComponent(next)}` : ''}`)} />
        </div>
      </div>
    </div>
  );
}
